import React from "react"

export const Footer = ({field, renderItem}) => {
  return (
    <div style={{ flexShrink: 0, marginLeft: 'auto', paddingTop: '.75rem', borderTop: '1px solid #dee2e6', width: '100%', display: 'inline-flex' }}>
      {field.items?.map((x: any) => renderItem(x))}
    </div>
  );
}